import React from 'react'
import Navber from "./Navber.jsx"
import HeroSection from './HeroSection.jsx'
import { motion } from "framer-motion";
import WeddingIntroSection from './WeddingIntroSection.jsx';
import FeaturedProperties from './FeaturedProperties.jsx';
import OurClientCarousel from './OurClientCarousel.jsx';
import Footer from './Footer.jsx';
import "./Home.css";
import AboutSection from './AboutSection.jsx';
import ServicesSection from './ServicesSection.jsx';
import LandingGalleryPreview from './PreviewGalleryImages.jsx';



function Home() {
  return (
    <div>

      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <FeaturedProperties />
      <LandingGalleryPreview />
      <OurClientCarousel />

    </div>
  )
}

export default Home